import React from "react";
import styles from "./styles.module.scss";
import { getReasonBadgeStyle, getReasonLabel } from "../../Pages/InstallPerformance/utils";

interface ReasonBadgeProps {
  reason: string | null;
}

const ReasonBadge = ({ reason }: ReasonBadgeProps) => {
  const style = getReasonBadgeStyle(reason);
  const label = getReasonLabel(reason);

  return (
    <span className={styles.badge} style={style}>
      {label}
    </span>
  );
};

export default ReasonBadge;
